import React from 'react';

const NotFoundPage = () => {
  return (
    <div class='pt-20 lg:pt-28 w-full h-[80vh]'>
      <iframe
        src="/404.html" // Путь к вашему 404.html
        title="404 Page"
        width="100%"
        height="100%"
        frameBorder="0"
        style={{ border: 'none' }}
      />
    </div>
  );
};

export default NotFoundPage;